import React, { memo } from 'react'
import {
  RainbowKitProvider,
  cssStringFromTheme,
  lightTheme
} from '@rainbow-me/rainbowkit'
import { WagmiProvider } from 'wagmi'
import { QueryClientProvider, QueryClient } from '@tanstack/react-query'

import { getChain, getWagmiConfig } from './wagmiConfig'

// const queryClient = new QueryClient({
//   defaultOptions: {
//     queries: {
//       staleTime: 0, // Always refetch on query call
//       cacheTime: 1000 * 60 * 5, // Cache data for 5 minutes
//       refetchOnWindowFocus: true, // Refetch when window regains focus
//       refetchInterval: 10000, // Refetch every 10 seconds
//       retry: 2 // Retry failed requests twice
//     }
//   }
// })

const queryClient = new QueryClient()

const WalletConnectWrapper = ({ children }) => {
  const customTheme = lightTheme({
    accentColor: '#00a0e3',
    fontStack: 'system'
  })
  return (
    <WagmiProvider config={getWagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider theme={null} initialChain={getChain()}>
          <style
            dangerouslySetInnerHTML={{
              __html: `
            :root {
              ${cssStringFromTheme(customTheme)}
            }
          `
            }}
          />
          {children}
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  )
}

export default memo(WalletConnectWrapper)
